import { useQuery } from "@tanstack/react-query";
import baggageTripsService from "services/admin/baggageTripsService";

export const useGetBaggageTrips = (queryParams = {}) => {
  return useQuery({
    queryKey: ["baggage-trips", queryParams],
    queryFn: async () => {
      const response = await baggageTripsService.getAll(queryParams);
      return response.data;
    },
  });
};
